// extracted by mini-css-extract-plugin
export var chevron = "_ch-4";
export var chevronExpanded = "_ch-5";
export var row = "_ch-0";
export var rowBody = "_ch-6";
export var rowDescription = "_ch-7";
export var rowHeader = "_ch-1";
export var rowTitle = "_ch-2";
export var rowTitleComplete = "_ch-3";